import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Club } from "@/models";

const getClubs = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "indexWithProfileId",
    storeKey: "clubs",
    loadingKey: "clubsLoading",
    metaKey: "meta",
    commitType: "index",
    params
  });

const getClub = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "show",
    storeKey: "club",
    loadingKey: "clubLoading",
    commitType: "wrappedShow2",
    params
  });

const getVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "getVideos",
    storeKey: "videos",
    loadingKey: "videosLoading",
    params
  });

const getLimitedVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "getVideosLimited",
    storeKey: "limitedVideos",
    loadingKey: "videosLoading",
    params
  });

const updateClub = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "update",
    storeKey: "club",
    loadingKey: "clubLoading",
    commitType: "wrappedShow2",
    message: "Club details updated",
    params
  });

const updateClubLogo = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "updateClubLogo",
    storeKey: "club",
    loadingKey: "clubLoading",
    commitType: "wrappedShow2",
    params
  });

const deleteClubVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "deleteClubVideos",
    storeKey: "video",
    loadingKey: "videosLoading",
    commitType: "wrappedShow2",
    message: "Video deleted.",
    params
  });

const saveClubVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "saveClubVideos",
    storeKey: "video",
    loadingKey: "videosLoading",
    commitType: "wrappedShow2",
    message: "New video added.",
    params
  });

const updateClubVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "updateClubVideos",
    storeKey: "video",
    loadingKey: "videosLoading",
    commitType: "wrappedShow2",
    message: "Video updated.",
    params
  });

const checkClubName = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "checkClubName",
    storeKey: "clubNameExists",
    loadingKey: "clubNameLoading",
    silent: "true",
    params
  });

const createClub = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "createClub",
    storeKey: "createClub",
    loadingKey: "createClubLoading",
    message: "Club Submitted For Verification",
    params
  });

const uploadClubImages = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "uploadClubImages",
    storeKey: "clubImages",
    loadingKey: "clubImagesLoading",
    message: "Images Uploaded",
    params
  });

const deleteClubImages = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "deleteClubImages",
    storeKey: "deleteImages",
    loadingKey: "deleteImagesLoading",
    message: "Image Deleted",
    params
  });

const removeDeletedVideoMutation = (context, params) =>
  context.commit("REMOVE_VIDEOS_MUTATION", params);

const setFavourite = (context, clubId) =>
  context.commit("SET_FAVOURITE", clubId);

const unsetFavourite = (context, clubId) =>
  context.commit("UNSET_FAVOURITE", clubId);

const getAllClubs = (context, params) =>
  restApiDispatcher(context, {
    resource: Club,
    action: "getAllClubs",
    storeKey: "allClubs",
    loadingKey: "allClubsLoading",
    silent: true,
    commitType: "index",
    params
  });

const updateViewCount = (context, params) => 
  restApiDispatcher(context, {
    resource: Club, 
    action: 'updateViewCount',
    storeKey: 'count',
    commitType: 'show',
    loadingKey: 'collegeLoading',
    params
  })
  
export default {
  getClubs,
  setFavourite,
  unsetFavourite,
  getClub,
  getVideos,
  updateClub,
  updateClubLogo,
  updateClubVideos,
  saveClubVideos,
  deleteClubVideos,
  removeDeletedVideoMutation,
  getLimitedVideos,
  checkClubName,
  createClub,
  uploadClubImages,
  deleteClubImages,
  getAllClubs,
  updateViewCount
};
